import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// Registered after load so it never delays first paint. Spec 7.2.
if ('serviceWorker' in navigator && location.protocol === 'https:') {
  window.addEventListener('load', () => {
    void navigator.serviceWorker
      .register('/sw.js', { updateViaCache: 'none' })
      .then((reg) => {
        // Check for a new worker on every open, and again hourly for a window
        // left running all day (spec 13.3).
        void reg.update().catch(() => undefined);
        setInterval(() => void reg.update().catch(() => undefined), 60 * 60_000);
      })
      .catch(() => undefined);

    // When a new worker takes over, reload once so the user is not left
    // looking at a half-old app. The guard stops a reload loop.
    let reloaded = false;
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data?.type === 'sw-updated' && !reloaded) {
        reloaded = true;
        location.reload();
      }
    });
  });
}
